import React from 'react'
import { Modal } from 'react-bootstrap'
import Button from "../components/Button"
import ButtonCancell from './ButtonCancell'

function SmallPopup(props) {

    return (
        <div >

            <Modal
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={props.smallmodalShow}
                onHide={() => props.setSmallModalShow(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" className='modal-title'>
                        {props.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {props.children}

                </Modal.Body>

                <Modal.Footer>
                    {props.closeButtonLabel &&
                        <ButtonCancell
                            className='btn button-cancell'
                            onClick={() => props.setSmallModalShow(false)}
                        >{props.closeButtonLabel}</ButtonCancell>
                    }

                    {props.okButtonLabel && <Button
                        type={props.type}
                        onClick={props.onSubmit}
                       // className='btn btn-regi btn-delete-popup'
                       className={`btn btn-regi btn-delete-popup ${props.className || ''}`}
                    >{props.okButtonLabel}</Button>
                    }

                </Modal.Footer>


            </Modal>

        </div>
    )
}

export default SmallPopup